import { GridItem, GridRow } from "commons/ui/Grid";

type PropsType = {
    proportion?: string;
    extensions?: string;
    desktopText?: string;
    mobileText?: string;
};

function ExtensionsProporsionInfo({
    proportion,
    extensions = "JPG",
    desktopText = "Desktop: 1500x844px (max 400KB)",
    mobileText = "Mobile: 1000x 563 px (max 250KB)",
}: PropsType) {
    return (
        <GridItem className={"extensions-proporsion-info"}>
            <GridRow>
                <GridItem>
                    <span>
                        Carica immagini in formato{" "}
                        <span className={"strong-text"}>{extensions}</span>{" "}
                        {proportion && (
                            <>
                                con proporzione <span className={"strong-text"}>{proportion}</span>
                            </>
                        )}
                    </span>
                </GridItem>
            </GridRow>

            {desktopText && (
                <GridRow>
                    <GridItem>
                        <span>Desktop: {desktopText}</span>
                    </GridItem>
                </GridRow>
            )}

            {mobileText && (
                <GridRow>
                    <GridItem>
                        <span>Mobile: {mobileText}</span>
                    </GridItem>
                </GridRow>
            )}
        </GridItem>
    );
}

export default ExtensionsProporsionInfo;
